export default {
    resizable: Boolean, 
    items: Array, 

    // Events
    click: Function, 
    close: Function, 
    open: Function, 
    toggle: Function, 
    overflowClose: Function, 
    overflowOpen: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/ToolBarProps.js